const map = {
	"./guild.json": 17087,
	"./items.json": 39848,
	"./lendingMessage.json": 84814,
	"./notificationMessage.json": 65478,
	"./specialRace.json": 18766,
	"i18n/vi/guild.json": 17087,
	"i18n/vi/items.json": 39848,
	"i18n/vi/lendingMessage.json": 84814,
	"i18n/vi/notificationMessage.json": 65478,
	"i18n/vi/specialRace.json": 18766
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3598;